// Why a refusal happened (D-07): a closed list, carried on the say event, the record entry and the
// audit event's detail. Evals score refusals by reason, never by matching copy.
import { z } from "zod";
export const RefusalReason = z.enum([
    "act-request",
    "ungrounded",
    "unknown-screen",
    "model-unavailable",
    "policy-blocked",
    "paused",
]);
//# sourceMappingURL=refusal.js.map